export function getStateIfNotExist(state: Record<string, any> | undefined, name: string) {
  if (!state || !(name in state)) return {};

  return state[name];
}
